import { render } from "./series-course-list.vue?vue&type=template&id=7a35685c&scoped=true"
import script from "./series-course-list.vue?vue&type=script&lang=ts"
export * from "./series-course-list.vue?vue&type=script&lang=ts"

import "./series-course-list.vue?vue&type=style&index=0&id=7a35685c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7a35685c"

export default script